<template>
  <div>

    <q-list v-if="fieldValue && fieldValue.real_estate && fieldValue.real_estate.length > 0"
            bordered separator padding class="rounded-borders q-mb-md">
      <template v-for="(place, place_index) in fieldValue.real_estate"
                :key="place_index">
      <q-item clickable v-ripple   active-class="bg-teal-1 text-grey-8" :active="place_index === index">
        <q-item-section avatar top>
          <q-avatar icon="s_home" color="grey" text-color="white" />
        </q-item-section>

        <q-item-section @click="selectRealEstate(place_index)">
          <q-item-label >
            <span class="q-mr-xs" v-if="fieldValue.real_estate[place_index].subject">(subject property)</span>
            <span class="q-mr-xs" v-if="fieldValue.real_estate[place_index].address">{{fieldValue.real_estate[place_index].address}}</span>
            <span class="q-mr-xs" v-if="fieldValue.real_estate[place_index].unit">{{fieldValue.real_estate[place_index].unit}},</span>
            <span class="q-mr-xs" v-if="fieldValue.real_estate[place_index].city">{{fieldValue.real_estate[place_index].city}},</span>
            <span class="q-mr-xs" v-if="fieldValue.real_estate[place_index].state">{{fieldValue.real_estate[place_index].state}},</span>
            <span class="q-mr-xs" v-if="fieldValue.real_estate[place_index].zip">{{fieldValue.real_estate[place_index].zip}}</span>
            </q-item-label>
        </q-item-section>

        <q-item-section side @click.stop="confirmDeleteAlert(place_index)">
          <q-icon name="s_delete" color="amber"  />
        </q-item-section>
      </q-item>
      </template>
    </q-list>
<!--    <div class="text-subtitle1 q-py-sm ">Add Current or Previous Job</div>-->

    <div class="row  ">
      <div class="col-12 q-py-sm q-ml-none col-md-12 q-gutter-sm q-gutter-y-md">


<!--        <q-btn-->
<!--            v-if="fieldValue.real_estate.length > 1"-->
<!--            class="mw-form-v2-btn-submit "-->
<!--            :flat="!settings.theme.next.cs ? settings.theme.button.flat: null"-->
<!--            :rounded="!settings.theme.next.cs ? settings.theme.button.rounded: null"-->
<!--            :round="!settings.theme.next.cs ? settings.theme.button.round: null"-->

<!--            :outline="true"-->
<!--            :push="!settings.theme.next.cs ? settings.theme.button.push: null"-->
<!--            :unelevated="!settings.theme.next.cs ? settings.theme.button.unelevated: true"-->
<!--            :noCaps="!settings.theme.next.cs ? settings.theme.button.noCaps: null"-->
<!--            :glossy="!settings.theme.next.cs ? settings.theme.button.glossy : null"-->
<!--            :size="settings.theme.next.cs ? settings.theme.next.size : settings.theme.button.size"-->

<!--            label="Remove this Real estate" type="button" color="primary"-->
<!--            :class="{'mw-form-v2-btn-next-cs':  settings.theme.next.cs}"-->
<!--            @click="confirmDeleteAlert(index)"-->
<!--        >-->
<!--        </q-btn>-->

        <q-btn

            class="mw-form-v2-btn-submit "
            :flat="!settings.theme.next.cs ? settings.theme.button.flat: null"
            :rounded="!settings.theme.next.cs ? settings.theme.button.rounded: null"
            :round="!settings.theme.next.cs ? settings.theme.button.round: null"

            :outline="true"
            :push="!settings.theme.next.cs ? settings.theme.button.push: null"
            :unelevated="!settings.theme.next.cs ? settings.theme.button.unelevated: true"
            :noCaps="!settings.theme.next.cs ? settings.theme.button.noCaps: null"
            :glossy="!settings.theme.next.cs ? settings.theme.button.glossy : null"
            :size="settings.theme.next.cs ? settings.theme.next.size : settings.theme.button.size"

            label="Add Real Estate Property Owned" type="button" color="primary"
            :class="{'mw-form-v2-btn-next-cs':  settings.theme.next.cs}"
            @click="AddItem()"
        >
        </q-btn>

<!--        <q-btn-->

<!--            class="mw-form-v2-btn-submit "-->
<!--            :flat="!settings.theme.next.cs ? settings.theme.button.flat: null"-->
<!--            :rounded="!settings.theme.next.cs ? settings.theme.button.rounded: null"-->
<!--            :round="!settings.theme.next.cs ? settings.theme.button.round: null"-->
<!--            color="black"-->
<!--            :outline="true"-->
<!--            :push="!settings.theme.next.cs ? settings.theme.button.push: null"-->
<!--            :unelevated="!settings.theme.next.cs ? settings.theme.button.unelevated: true"-->
<!--            :noCaps="!settings.theme.next.cs ? settings.theme.button.noCaps: null"-->
<!--            :glossy="!settings.theme.next.cs ? settings.theme.button.glossy : null"-->
<!--            :size="settings.theme.next.cs ? settings.theme.next.size : settings.theme.button.size"-->

<!--            label="I have no source of income" type="button"-->
<!--            :class="{'mw-form-v2-btn-next-cs':  settings.theme.next.cs}"-->
<!--            @click="noSourceOfIncome()"-->
<!--        >-->
<!--        </q-btn>-->


      </div>
    </div>
    <q-field class="field_no_bottom_line" :hide-bottom-space="true"   :rules="[val => isValid() || (field.required_text ? field.required_text :  'Must Enter at least one real_estate_item')]">
    </q-field>

    <q-dialog v-model="confirm" persistent>
      <q-card>
        <q-card-section class="row   items-center">
          <q-avatar icon="s_place" color="primary" text-color="white" />
          <span class="q-ml-sm">Switch to this address will clear a current item.</span>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Cancel" color="primary" v-close-popup />
          <q-btn flat label="Confirm" @click="clearCurrentAndSwitch()" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog v-model="confirmDelete" persistent>
      <q-card>
        <q-card-section class="row   items-center">
          <q-avatar icon="s_place" color="primary" text-color="white" />
          <span class="q-ml-sm">Are you sure to delete this address {{fieldValue.real_estate[confirmDeleteIndex] && fieldValue.real_estate[confirmDeleteIndex].address}}?</span>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Cancel" color="primary" v-close-popup />
          <q-btn flat label="Delete" @click="deleteItem()" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>


    <q-dialog v-model="editModalVisible" persistent>
      <q-card style="width: 800px; max-width: 100%;">
        <q-card-section class="">
          <ModuleBorrowerRealEstateOwn ref="module" v-model="fieldValue.real_estate[index]"></ModuleBorrowerRealEstateOwn>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Remove this property" @click="confirmDelete = true" color="primary"  />
          <q-btn flat label="Confirm" @click="Confirm()" color="primary"/>
        </q-card-actions>
      </q-card>
    </q-dialog>

  </div>
</template>

<script>
import {mapFields} from "vuex-map-fields";

import ModuleBorrowerRealEstateOwn from "@/components/modules/ModuleBorrowerRealEstateOwn";

import {mapActions} from "vuex";
export default {
  components: {
    ModuleBorrowerRealEstateOwn,
  },
  props: {
    modelValue: {},
    field:{}
  },
  data() {
    return {
        editModalVisible: false,
        confirm: false,
        confirmIndex: null,
        confirmIndexToClear: null,
        confirmDelete: false,
        confirmDeleteIndex: null,
        types:[
          { label: 'This is my current real_estate_item', value: 'Current' },
          { label: 'This is a previous real_estate_item', value: 'Previous'}
        ],
        share_sizes:[
          { label: 'I have an ownership share of 25% or more', value: 'more then 25%' },
          { label: 'I have an ownership share of less than 25%', value: 'less then 25%'}
        ],
        real_estate_item: {
          address: "",
          unit: "",
          city: "",
          state: "",
          zip: "",
          country: "",
          property_type: "",
          status: "",
          intended_occupancy: "",
          market_value: "",
          monthly_gross_rent_income: "",
          current_mortgage_balance: "",
          monthly_rent_net_income: "",
          monthly_mortgage_payment: "",
          monthly_insurance: "",
          loans: [],
        },

        loan_types: {},
        real_estate:[

        ],
        index: null
    };
  },
  emits: ['update:modelValue'],
  methods: {
    ...mapActions({
      nextScreen: 'values/list/nextScreen'
    }),
    noSourceOfIncome() {
      this.fieldValue.no_source_of_income = true;
      //this.fieldValue.real_estate = [];
      this.nextScreen({form : this.form});
    },
    isValidRealEstate(index) {
      const real_estate_item = this.fieldValue.real_estate[index];
      return !(!real_estate_item.address
          || !real_estate_item.city
          || !real_estate_item.state
          || !real_estate_item.zip
          || real_estate_item.years === ""
          || real_estate_item.years === null
          || real_estate_item.months === ""
          || real_estate_item.months === null);

    },
    isValid () {
      return !this.field.required || this.fieldValue.real_estate.length > 0;
    },
    Confirm() {
      this.$refs.module.validate().then(success => {
        if (success) {
          this.editModalVisible = false;
        }
      });
    },
    generateId() {
      return new Date().getTime() + '_' + Math.random();
    },
    AddItem() {
      this.index = this.fieldValue.real_estate.push(Object.assign({id: this.generateId()}, this.real_estate_item)) - 1;
      this.confirmDeleteIndex = this.index;
      this.confirmIndex = this.index;
      this.editModalVisible = true;
      //this.$refs.module.reset();
    },
    onSubmit() {
      this.fieldValue.real_estate[this.index].valid = true;
      this.index = this.fieldValue.real_estate.push(Object.assign({}, this.real_estate_item)) - 1;
      this.$refs.form.reset();
    },
    onAddressSelected(real_estate_item) {
      this.fieldValue.real_estate[this.index].city = real_estate_item.city;
      this.fieldValue.real_estate[this.index].state = real_estate_item.state;
      this.fieldValue.real_estate[this.index].zip = real_estate_item.zipcode;
    },
    selectRealEstate(place_index) {
      //this.$refs.form.resetValidation();
      this.confirmIndex = place_index;
      this.confirmDeleteIndex = place_index;
      this.confirmIndexToClear = this.index;
      this.index = place_index;
      this.editModalVisible = true;
    },
    clearCurrentAndSwitch() {
      this.$refs.form.reset();
      this.index = this.confirmIndex;
      this.fieldValue.real_estate.splice(this.confirmIndexToClear, 1);
    },
    confirmDeleteAlert(index) {

      this.confirmDeleteIndex = index;
      this.confirmDelete = true;

    },
    deleteItem() {
      this.editModalVisible = false;
      // if(this.fieldValue.real_estate.length === 1) {
      //   this.fieldValue.real_estate.push(Object.assign({}, this.real_estate_item));
      // }
      this.fieldValue.real_estate.splice(this.confirmDeleteIndex, 1);
      this.index = this.fieldValue.real_estate.length -1;

    },
    getFieldValueByFieldType(type) {
      for(let key in this.form.screens) {
        for (let keyF in this.form.screens[key].fields) {
          const field = this.form.screens[key].fields[keyF];
          if(type === field.type) {
            return this.fieldValues[field.id];
          }
        }
      }
      return null;
    }
  },
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings',
      form: 'form'
    }),
    ...mapFields('values/list', {
      fieldValues: 'fieldValues'
    }),
    requiredText: function () {
      return this.field.required_text ? this.field.required_text : 'Please select';
    },
    fieldValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    }
  },
  mounted() {


      let prefix = 'borrower';

     // console.log(this.field);
      if(this.field.type === 'co_borrower.real_estate_own.component') {
        prefix = 'co_borrower';
      }

      const value = this.getFieldValueByFieldType(prefix + '.address.history');

      const address_history_items = [];
      if(value && value.locations && value.locations.length > 0) {
        for(const i in value.locations) {
          const location = value.locations[i];
          if(location.own_type === 'Own') {
            address_history_items[location.id] = location;
            address_history_items[location.id].intended_occupancy = "primary_residence";
          }
        }
      }

      let fieldValue = {real_estate: []};
      if(this.fieldValue !== undefined && this.fieldValue !== null && this.fieldValue.real_estate !== undefined) {
        fieldValue = Object.assign({}, this.fieldValue);
      }


    const purpose = this.getFieldValueByFieldType('loan.purpose');
    if(purpose === 'Refinance' && prefix === 'borrower') {
      const address = this.getFieldValueByFieldType('property.address');
      const city = this.getFieldValueByFieldType('property.city');
      const state = this.getFieldValueByFieldType('property.state');
      //const county = this.getFieldValueByFieldType('property.county');
      const zipcode = this.getFieldValueByFieldType('property.zipcode');
      //const number_of_units = this.getFieldValueByFieldType('property.number_of_units');
      const type = this.getFieldValueByFieldType('property.type');
      const intended_use = this.getFieldValueByFieldType('property.intended_use');
      const refinance_type = this.getFieldValueByFieldType('loan.refinance.type');
      const lender = this.getFieldValueByFieldType('loan.refinance.lender');
      const original_cost = this.getFieldValueByFieldType('loan.refinance.original_cost');
      const existing_lien = this.getFieldValueByFieldType('loan.refinance.existing_lients');
      const subjectProperty = {
        id: this.generateId(),
        subject: true,
        address: address,
        city: city,
        state: state,
        zip: zipcode,
        property_type: type,
        intended_occupancy: intended_use,
        market_value: original_cost,
        loans: [
          {
            creditor_name: lender,
            unpaid_balance: existing_lien,
            type: refinance_type
          }
        ]
      };

      let alreadyAdded = false;
      for (let i in fieldValue.real_estate) {
        if(fieldValue.real_estate[i].subject === true) {
          fieldValue.real_estate[i] = Object.assign({info: false}, fieldValue.real_estate[i],  subjectProperty);
          alreadyAdded = true;
        }
      }
      if(!alreadyAdded) {
        fieldValue.real_estate.push(Object.assign({info: false}, subjectProperty));
      }
    }



      const real_estate_from_history = [];
      for (let i in fieldValue.real_estate) {
        if(fieldValue.real_estate[i].id) {
          real_estate_from_history[fieldValue.real_estate[i].id] = fieldValue.real_estate[i];
        }
      }


      for (let i in address_history_items) {
        if(address_history_items[i].own_type ==='Own' && !real_estate_from_history[address_history_items[i].id]) {
          fieldValue.real_estate.push(Object.assign({info: false}, address_history_items[i]));
        }
      }

      this.fieldValue = fieldValue;
      this.index = null;
  }
}
</script>
<style>
.field_no_bottom_line .q-field__control:before {
  border-bottom-color: transparent !IMPORTANT;
}
.field_no_bottom_line  .q-field__control:after {
  background: none !important;
}
.field_no_bottom_line .q-field__control {
  display: none;
}
</style>
